import { render } from "./Autoservice.vue?vue&type=template&id=3da78602"
import script from "./Autoservice.vue?vue&type=script&lang=js"
export * from "./Autoservice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__